import React, { useState, useMemo } from "react";
import {
  Grid,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import { SearchIcon } from "@icarius-icons";
import UserSection from "./userSection";
import { getLocalizedString } from "@icarius-localization/strings";

const UserSelectionColumn = (props) => {

  const {
    employees,
    filterPlaceholder,
    loggedUserIsDisabled,
    noAvatar,
    handleClick,
  } = props;

  const [searchValue, setSearchValue] = useState("");

  const filteredEmployees = useMemo(() => {
    if (!searchValue) return employees;

    return [...employees].filter((item) => {
      return item.name && item.name.toLowerCase().includes(searchValue.toLowerCase());
    });
  }, [employees, searchValue])

  return (
    <Grid container direction="row" item xs={12} md={6}>
      <Grid item xs={12} style={{ paddingBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", height: 32 }}>
          <TextField
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder={filterPlaceholder || getLocalizedString("searchEmployee")}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <UserSection
          employees={filteredEmployees}
          handleClick={handleClick}
          loggedUserIsDisabled={loggedUserIsDisabled}
          isSelection={true}
          noAvatar={noAvatar}
        />
      </Grid>
    </Grid>
  );
}

export default UserSelectionColumn;
